type RequireCtx = {
  keys: () => string[];
  (key: string): unknown;
};

const loadCtx = (): RequireCtx => {
  // Webpack environment — rewrites this literal call into a ContextModule
  // at build time. In a non-webpack environment (Jest/Node), `require.context`
  // is undefined and the call throws, so we fall back to fs.
  try {
    // @ts-ignore — `require.context` is webpack-specific (types live in
    // @types/webpack-env, which is not bundled with CRA).
    return require.context('../../assets/images/banks', false, /\.svg$/);
  } catch {
    // eslint-disable-next-line no-eval
    const nodeRequire = eval('require') as NodeRequire;
    const fs = nodeRequire('fs') as typeof import('fs');
    const path = nodeRequire('path') as typeof import('path');
    const dir = path.resolve(__dirname, '../../assets/images/banks');
    const files = fs.readdirSync(dir).filter((f) => f.endsWith('.svg'));
    const keys = files.map((f) => `./${f}`);
    const fn = ((key: string) =>
      path.join(dir, key.replace(/^\.\//, ''))) as RequireCtx;
    fn.keys = () => keys;
    return fn;
  }
};

const ctx = loadCtx();

const FILES: ReadonlySet<string> = new Set(
  ctx.keys().map((k) => k.replace(/^\.\/(.+)\.svg$/, '$1')),
);

const norm = (value: string): string => value.toLowerCase().trim();

export const hasBankLogo = (code?: string | null): boolean => {
  if (!code) return false;
  return FILES.has(norm(code));
};

export const resolveLogo = (code: string, isDark: boolean): string | undefined => {
  const lc = norm(code);
  if (!FILES.has(lc)) return undefined;
  const fileName = isDark && FILES.has(`${lc}-dark`) ? `${lc}-dark` : lc;
  const mod = ctx(`./${fileName}.svg`) as string | { default: string };
  return typeof mod === 'string' ? mod : mod.default;
};
